import AccountService from '../services/account.service'

export const accountModule = {
  namespaced: true,

  state: {
    accounts: [],
    accountDetail: null,
    account: null,
    criterias: null,
    invalidData: null
  },

  actions: {
    async search ({ commit }, criterias) {
      return AccountService.search(criterias).then(
        response => {
          const accounts = response.data
          commit('searchSuccess', accounts)
          return Promise.resolve(accounts)
        },
        error => {
          commit('searchFailure')
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async getBeneficiaryAccountDetails ({ commit }, criterias) {
      return AccountService.getBeneficiaryAccountDetails(criterias).then(
        response => {
          const accountDetail = response.data
          commit('detailSuccess', accountDetail)
          return Promise.resolve(accountDetail)
        },
        error => {
          commit('detailFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async getFunderAccountDetails ({ commit }, criterias) {
      return AccountService.getFunderAccountDetails(criterias).then(
        response => {
          const accountDetail = response.data
          commit('detailSuccess', accountDetail)
          return Promise.resolve(accountDetail)
        },
        error => {
          commit('detailFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async reset ({ commit }) {
      commit('listReset')
    },

    async detailReset ({ commit }) {
      commit('detailReset')
    },

    async setAccount( { commit }, account) {
      commit('accountSuccess', account)
    },

    async setCriterias ({ commit }, criterias) {
      commit('setCriterias', criterias)
    },

    async resetCriterias ({ commit }) {
      commit('resetCriterias')
    },

    async invalidData ({ commit }, error) {
      commit('invalidData', error)
    },

    async resetInvalidData ({ commit }) {
      commit('invalidData', null)
    }
  },

  mutations: {
    detailSuccess (state, account) {
      state.accountDetail = account
    },
    detailFailure (state) {
      state.accountDetail = null
    },
    listReset (state) {
      state.accounts = []
    },
    searchSuccess (state, accounts) {
      state.accounts = accounts
    },
    searchFailure (state) {
      state.accounts = []
    },
    detailReset (state) {
      state.accountDetail = null
    },
    accountSuccess (state, account) {
      state.account = account
    },
    setCriterias (state, criterias) {
      state.criterias = criterias
    },
    resetCriterias (state) {
      state.criterias = null
    },
    invalidData (state, error) {
      state.invalidData = error
    }
  }
}
